module.exports = __webpack_public_path__ + "static/oculus-rift-aa15449ea38e8ceb1b8ea3eb4cf8042c.png";